<script>
	export let defaultOption;
	export let id;
	export let label;
	export let name;
	export let options;
	export let required = false;
	export let value;
</script>

<label for={id}>{@html label}</label>
<select bind:value {id} {name} {required}>
	{#if defaultOption}
		<option value="" selected>{defaultOption}</option>
	{/if}
	{#each options as option}
		<option value={option}>{option}</option>
	{/each}
</select>